module.exports = __webpack_public_path__ + "img/3-1.35a0eaa0.png";